export default __webpack_public_path__ + "static/media/gl_arrow_up.8eb1de2b.svg";